import { TimepickerConfig } from 'ngx-bootstrap/timepicker';

export function getTimepickerConfig(): TimepickerConfig {
  return Object.assign(new TimepickerConfig(), {
    minuteStep: 15,
    showMeridian: false,
    mousewheel: true,
    showMinutes: true,
    showSeconds: false,
    showSpinners: false
  });
}
